var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChartUp06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 21H4.79998C4.23993 21 3.9599 21 3.74599 20.891C3.55783 20.7951 3.40485 20.6422 3.30898 20.454C3.19998 20.2401 3.19998 19.9601 3.19998 19.4V3M20.2 6H16.2M20.2 6V9.5M20.2 6C13.7 11.5 10.7 14 6.19998 18",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartUp06);
export default __webpack_public_path__ + "static/media/line-chart-up-06.3a67c69cba88b2593d85a864e93472c1.svg";
export { ForwardRef as ReactComponent };